import { __awaiter } from "tslib";
import React, { useEffect, useState } from 'react';
import { isNil } from 'ramda';
import { useAppDispatch } from '@/store/hooks';
import { useLazyGetEmbedSsoUrl } from '@/platform-services/analytics';
import { AnalyticsWrapper, FullContainer, LoadingOverlay } from '../analytics.styles';
import { useAnalyticsContext } from '../analytics.context';
import { AdhocMessageBar } from '@/adhoc-message/adhoc-message-bar.component';
import { addError } from '@/store/slices/notificationsSlice';
import { useGoToUrl, usePathname } from '@/routing/hooks/utils';
import { normalizeDashboardTitle } from '@/search-for-retail/analytics';
import { generateCollectionAreaUrl } from '@/search-for-retail/utilities';
import { PageIdentifier, Routing } from '@/constants';
import { SimpleLoading } from '@/components/loading.component';
import { excludedDashboardsFromRoute } from '../analytics.utils';
import SplashScreen from '@/search-for-retail/splash-screen/splash-screen';
import { logError } from '@/utils/logger';
import { useSessionAreaName, useSessionCollectionName } from '@/platform-services/session';
export const AnalyticsDashboard = ({ dashboard }) => {
    const dispatch = useAppDispatch();
    const collectionName = useSessionCollectionName();
    const areaName = useSessionAreaName();
    const pathname = usePathname();
    const paths = pathname.split('/');
    const goToUrl = useGoToUrl();
    const { setIsLoadingDashboards } = useAnalyticsContext();
    const [embedSsoUrl, setEmbedSsoUrl] = useState();
    const [showSplashScreen, setShowSplashScreen] = useState(false);
    const [loading, setLoading] = useState(false);
    const { triggerGetEmbedSsoUrl } = useLazyGetEmbedSsoUrl();
    useEffect(() => {
        const action = () => __awaiter(void 0, void 0, void 0, function* () {
            if (isNil(areaName) || !dashboard) {
                setShowSplashScreen(true);
                return;
            }
            try {
                setLoading(true);
                const foundEmbedSsoUrl = yield triggerGetEmbedSsoUrl({ path: dashboard.embedPath, areaName });
                setEmbedSsoUrl(foundEmbedSsoUrl);
                setShowSplashScreen(false);
            }
            catch (error) {
                const errorMessage = 'LOAD_ANALYTICS_ERROR';
                logError(errorMessage, error);
                dispatch(addError({ key: errorMessage }));
                setShowSplashScreen(true);
            }
        });
        void action();
    }, [areaName, dispatch, dashboard, triggerGetEmbedSsoUrl]);
    useEffect(() => {
        setIsLoadingDashboards(isNil(embedSsoUrl));
    }, [embedSsoUrl, setIsLoadingDashboards]);
    useEffect(() => {
        if (isNil(collectionName) || isNil(areaName) || !dashboard)
            return;
        if (excludedDashboardsFromRoute.includes(dashboard.title))
            return;
        const dashboardFromRoute = paths[5];
        if (!dashboardFromRoute) {
            const url = generateCollectionAreaUrl(collectionName, PageIdentifier.ANALYTICS, areaName);
            goToUrl(`${Routing.MERCHANDISING_PATH}/analytics${url}/${normalizeDashboardTitle(dashboard.title)}`);
        }
    }, [collectionName, areaName, paths, goToUrl, dashboard]);
    useEffect(() => {
        setLoading(true);
    }, [dashboard === null || dashboard === void 0 ? void 0 : dashboard.id, areaName]);
    if (!dashboard || showSplashScreen) {
        return <SplashScreen />;
    }
    return (<AnalyticsWrapper>
      <React.Fragment>
        <FullContainer>
          {loading && (<LoadingOverlay>
              <SimpleLoading />
            </LoadingOverlay>)}
          <AdhocMessageBar placement="analytics-dashboard"/>
          <iframe onLoad={() => setLoading(false)} id={dashboard.id.toString()} title={dashboard.title} src={embedSsoUrl} width="100%" height="100%" frameBorder="none"/>
        </FullContainer>
      </React.Fragment>
    </AnalyticsWrapper>);
};
export default AnalyticsDashboard;
